import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MoveRelatedApiModel, PeFormWorkflowStepApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PpFormWorkflowStepsService {
  public apiUrl = 'pp-form-workflow-steps';

  constructor(private readonly http: HttpClientService) {}

  public delete(id: number): Observable<Object> {
    return this.http.delete(`${this.apiUrl}/delete/${id}`);
  }

  public update(model: PeFormWorkflowStepApiModel): Observable<PeFormWorkflowStepApiModel> {
    return this.http
      .put<PeFormWorkflowStepApiModel>(`${this.apiUrl}/update`, model)
      .pipe(map((response) => new PeFormWorkflowStepApiModel().deserialize(response)));
  }

  public add(model: PeFormWorkflowStepApiModel): Observable<PeFormWorkflowStepApiModel> {
    return this.http
      .post<PeFormWorkflowStepApiModel>(`${this.apiUrl}/add`, model)
      .pipe(map((response) => new PeFormWorkflowStepApiModel().deserialize(response)));
  }

  public move(model: MoveRelatedApiModel<number, number>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, model);
  }
}
